export default "__VITE_ASSET__CEqEnWNJ__"